import { createContext, useContext } from "react";

export const DashContext = createContext({ data: null, cardProps: {}, reload: () => {} });
export const useDash = () => useContext(DashContext);
